import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { OfferContext, getHelpDrawerCollection } from '@adac-mp/shared';
import { ContentLoader, Richtext, Typography } from '../../index';

interface IContentfulDrawerContentProps {
	id: string;
	hideHeadline?: boolean;
	className?: string;
}

export const ContentfulDrawerContent = ({ id, hideHeadline, className }: IContentfulDrawerContentProps) => {
	const { lang } = useContext(OfferContext);
	const { loading, data } = useQuery(getHelpDrawerCollection, {
		variables: { lang: lang || 'de', id },
	});

	const drawerContent = data?.helpDrawerCollection.items[0];

	if (loading || !drawerContent)
		return <ContentLoader isLoading hasPortal={false} height="h-[calc(100dvh_-_69px)]" />;

	return (
		<div className={`py-6 md:py-8 ${className}`}>
			{drawerContent?.headline && !hideHeadline && (
				<Typography className="font-normal pb-6 md:pb-8" component="h3" color="title" size="h2">
					{drawerContent?.headline ?? ''}
				</Typography>
			)}
			<div className="flex flex-col gap-4">
				<Typography color="text" size="xlSpace">
					{drawerContent && drawerContent.helpDrawerRichText ? (
						<Richtext document={drawerContent.helpDrawerRichText} />
					) : (
						''
					)}
				</Typography>
			</div>
		</div>
	);
};
